import React from "react";

function Navbar() {
  return (
    <nav>
      <a href="/">
        <img
          id="logo"
          src="http://pvppcoe.ac.in/assets/img/VISUAL%20ART%20LOGO%201.png"
          alt="VPPCOE logo"
        ></img>
      </a>
      <h1 id="name2">VPPCOE</h1>
      <h1 id="name">
        Vasantdada Patil Pratishthan's College of Engineering & Visual Arts
      </h1>
    </nav>
  );
}

export default Navbar;
